/* EcomX 16 Oct 2026 - "Save more" nudges across the site (no forced spend).
   - Slim strip on every page: mix any 4 for ₹699 / 8 for ₹999, no minimum.
   - Product pages (agarbatti + dhoop): a "save more by mixing" box under Add to cart.
   - Cart page: if the cart already has 4+ eligible packs, one tap applies the bundle price
     (customer pays LESS for the same packs). Otherwise a gentle "add X more to save ₹Y". */
(function () {
  var path = location.pathname;
  if (/\/pages\/build-your-bundle/.test(path)) return;
  var OFFER = "/pages/build-your-bundle#offer";
  var BUNDLE_PRODUCT_ID = 16074067116401;
  var TIERS = [
    { qty: 8, price: 999, label: "Any 8 @ ₹999", variant: 67761564451185 },
    { qty: 4, price: 699, label: "Any 4 @ ₹699", variant: 67761564418417 }
  ];
  // variant id -> [packs in this variant, short name, Pack-of-1 variant id]
  var V = {};
  [["Shiv Mangal Agarbatti", [64576576356721, 64576576389489, 64576576422257, 64576576455025]],
   ["Kesari Nandan Agarbatti", [64576576979313, 64576577012081, 64576577044849, 64576577077617]],
   ["Gyaan Ganga Agarbatti", [64576576029041, 64576576061809, 64576576094577, 64576576127345]],
   ["Nandlal Agarbatti", [64576576717169, 64576576749937, 64576576782705, 64576576815473]],
   ["Shubh Laxmi Agarbatti", [64576576192881, 64576576225649, 64576576258417, 64576576291185]],
   ["Vighnaharta Agarbatti", [64576575865201, 64576575897969, 64576575930737, 64576575963505]]
  ].forEach(function (p) { p[1].forEach(function (id, i) { V[id] = [i + 1, p[0], p[1][0]]; }); });
  [["Shiv Mangal Dhoop Sticks", 64576575701361], ["Kesari Nandan Dhoop Sticks", 64576575832433],
   ["Gyaan Ganga Dhoop Sticks", 64576575537521], ["Nandlal Dhoop Sticks", 64576575734129],
   ["Shubh Laxmi Dhoop Sticks", 64576575635825], ["Vighnaharta Dhoop Sticks", 64576575504753]
  ].forEach(function (p) { V[p[1]] = [1, p[0], p[1]]; });
  var HANDLES = ["shiv-mangal-agarbatti", "kesari-nandan-agarbatti", "gyaan-ganga-agarbatti", "nandlal-agarbatti", "shubh-laxmi-agarbatti", "vighnaharta-agarbatti",
    "shiv-mangal-dhoop-sticks", "kesari-nandan-dhoop-sticks", "gyaan-ganga-dhoop-sticks", "nandlal-dhoop-sticks", "shubh-laxmi-dhoop-sticks", "vighnaharta-dhoop-sticks"];

  var inr = function (n) { return "₹" + Math.round(Number(n)).toLocaleString("en-IN"); };

  var css = document.createElement("style");
  css.textContent =
    ".ssm-strip{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;padding:7px 36px 7px 12px;background:#fbf3e6;color:#3a2a1a;font-size:13px;line-height:1.3;text-align:center;position:relative;border-bottom:1px solid #efdfc6}" +
    "@media (max-width:749px){.ssm-strip{flex-wrap:nowrap;white-space:nowrap;font-size:12px;gap:6px}.ssm-strip .ssm-nomin{display:none}}" +
    ".ssm-strip b{color:#9b1c1c}.ssm-strip a{color:#9b1c1c;font-weight:600;text-decoration:underline;white-space:nowrap}" +
    ".ssm-strip button{position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:0;font-size:18px;line-height:1;cursor:pointer;color:#7a6a58;padding:4px 8px}" +
    ".ssm-box{margin:14px 0;padding:14px 16px;border:1px dashed #c9a46a;border-radius:14px;background:#fffaf2;color:#2b2118;font-size:14px;line-height:1.45}" +
    ".ssm-box h4{margin:0 0 6px;font-size:15px;font-weight:600;color:#9b1c1c}" +
    ".ssm-row{display:flex;gap:8px;flex-wrap:wrap;margin:8px 0}" +
    ".ssm-chip{background:#fff;border:1px solid #ead9bd;border-radius:999px;padding:5px 11px;font-size:13px}" +
    ".ssm-chip b{color:#9b1c1c}" +
    ".ssm-btn{display:inline-block;margin-top:6px;background:#9b1c1c;color:#fff!important;border:0;border-radius:999px;padding:9px 16px;font-size:13.5px;font-weight:600;cursor:pointer;text-decoration:none}" +
    ".ssm-link{color:#9b1c1c;font-weight:600;text-decoration:underline}" +
    ".ssm-muted{font-size:12.5px;color:#6b5d4f;margin-top:4px}";
  document.head.appendChild(css);

  function plan(units) {
    var u = units.slice().sort(function (a, b) { return b.price - a.price; });
    var groups = [], i = 0, pay = 0;
    for (;;) {
      var picked = null;
      for (var j = 0; j < TIERS.length && !picked; j++) {
        var t = TIERS[j];
        if (u.length - i < t.qty) continue;
        var s = 0;
        for (var m = i; m < i + t.qty; m++) s += u[m].price;
        if (t.price < s) picked = t;
      }
      if (!picked) break;
      groups.push({ tier: picked, units: u.slice(i, i + picked.qty) });
      pay += picked.price; i += picked.qty;
    }
    var extras = u.slice(i);
    extras.forEach(function (x) { pay += x.price; });
    return { pay: pay, groups: groups, extras: extras };
  }
  function sum(u) { var s = 0; u.forEach(function (x) { s += x.price; }); return s; }

  /* 1) Strip on every page (except cart, which gets its own box) */
  function strip() {
    if (/^\/cart/.test(path)) return;
    try { if (sessionStorage.getItem("ssm-strip-off")) return; } catch (e) {}
    var main = document.getElementById("MainContent");
    if (!main || document.querySelector(".ssm-strip")) return;
    var d = document.createElement("div");
    d.className = "ssm-strip";
    d.innerHTML = "<span>Mix &amp; save: <b>4 for ₹699</b> · <b>8 for ₹999</b><span class=\"ssm-nomin\"> · no minimum</span></span>" +
      '<a href="' + OFFER + '">Shop the mix →</a><button type="button" aria-label="Close">×</button>';
    d.querySelector("button").addEventListener("click", function () {
      d.remove(); try { sessionStorage.setItem("ssm-strip-off", "1"); } catch (e) {}
    });
    main.insertBefore(d, main.firstChild);
    // Some sections (e.g. the home hero) pull themselves up under the header with a negative
    // margin. Push them down by the same amount so the strip never covers them.
    var fix = function () {
      d.style.marginBottom = "0px";
      var nx = d.nextElementSibling, bottom = d.getBoundingClientRect().bottom, top = Infinity;
      if (!nx) return;
      Array.prototype.forEach.call(nx.children, function (c) {
        if (c.offsetHeight > 0) top = Math.min(top, c.getBoundingClientRect().top);
      });
      var overlap = Math.round(bottom - top);
      if (overlap > 0 && overlap < 200) d.style.marginBottom = overlap + "px";
    };
    fix(); window.addEventListener("load", fix); window.addEventListener("resize", fix);
  }

  /* 2) Product page box */
  function pdp() {
    var m = path.match(/\/products\/([^\/?#]+)/);
    if (!m || HANDLES.indexOf(m[1]) < 0) return;
    var add = document.querySelector('button[data-act="add"]');
    if (!add || document.querySelector(".ssm-box")) return;
    var notes = Array.prototype.filter.call(document.querySelectorAll("p,div,span"), function (el) {
      return /^\s*Inclusive of all taxes/i.test(el.textContent) && el.textContent.length < 120 && el.offsetHeight > 0;
    });
    notes = notes.filter(function (el) { return !notes.some(function (o) { return o !== el && el.contains(o); }); });
    var anchor = notes.length ? notes[0] : add;
    var box = document.createElement("div");
    box.className = "ssm-box";
    box.innerHTML = "<h4>Save more by mixing fragrances</h4>" +
      "Pick this with any other agarbatti or dhoop — repeats allowed, no minimum." +
      '<div class="ssm-row"><span class="ssm-chip">Any 4 · <b>₹699</b> (₹175/pack)</span><span class="ssm-chip">Any 8 · <b>₹999</b> (₹125/pack)</span></div>' +
      '<a class="ssm-btn" href="' + OFFER + '">Build my mix →</a>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  /* 3) Cart page: apply the best price to packs already in the cart */
  function post(url, body) {
    return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function listOf(units) {
    var c = {}, order = [];
    units.forEach(function (x) { if (!c[x.name]) { c[x.name] = 0; order.push(x.name); } c[x.name]++; });
    return order.map(function (nm) { return c[nm] + " × " + nm; }).join(", ");
  }
  function cartBox() {
    if (!/^\/cart\/?$/.test(path)) return;
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var units = [], lines = [];
        (cart.items || []).forEach(function (it) {
          var pr = it.properties || {}, info = V[it.variant_id];
          if (!info || it.product_id === BUNDLE_PRODUCT_ID || pr.Bundle) return;
          var per = it.price / 100 / info[0];
          lines.push(it.key);
          for (var q = 0; q < it.quantity * info[0]; q++) units.push({ id: info[2], price: per, name: info[1] });
        });
        if (!units.length) return;
        var p = plan(units), save = sum(units) - p.pay;
        var host = null;
        var summ = Array.prototype.filter.call(document.querySelectorAll("summary"), function (s) { return /Have a code/i.test(s.textContent); })[0];
        if (summ) host = summ.closest("details");
        if (!host) { var sr = document.querySelector(".sr-button-text-container"); host = sr && sr.closest("button"); }
        if (!host || document.querySelector(".ssm-box")) return;
        var box = document.createElement("div");
        box.className = "ssm-box";
        if (save > 0) {
          box.innerHTML = "<h4>You can save " + inr(save) + " on these packs</h4>" +
            "Your " + units.length + " packs qualify for the mix &amp; match price. Same packs, lower price." +
            '<div><button type="button" class="ssm-btn">Apply ' + inr(save) + " saving</button></div>" +
            '<div class="ssm-muted">New total for these packs: ' + inr(p.pay) + "</div>";
          box.querySelector("button").addEventListener("click", function (e) {
            var b = e.currentTarget; b.disabled = true; b.textContent = "Applying…";
            var updates = {}; lines.forEach(function (k) { updates[k] = 0; });
            var items = p.groups.map(function (g) {
              return { id: g.tier.variant, quantity: 1, properties: { Bundle: g.tier.label, Fragrances: listOf(g.units), _picks: g.units.map(function (x) { return x.id; }).join(",") } };
            });
            var ex = {}; p.extras.forEach(function (x) { ex[x.id] = (ex[x.id] || 0) + 1; });
            Object.keys(ex).forEach(function (id) { items.push({ id: +id, quantity: ex[id], properties: { _ssoffer: "1" } }); });
            post("/cart/update.js", { updates: updates })
              .then(function () { return post("/cart/add.js", { items: items }); })
              .then(function () { location.reload(); })
              .catch(function () { b.disabled = false; b.textContent = "Try again"; });
          });
        } else {
          var k = units.length < 4 ? 4 - units.length : 8 - units.length;
          if (k <= 0) return;
          var more = units.slice(); for (var z = 0; z < k; z++) more.push({ id: 0, price: 189, name: "" });
          var s2 = sum(more) - plan(more).pay;
          if (s2 <= 0) return;
          box.innerHTML = "<h4>Want to save more?</h4>Add " + k + " more pack" + (k > 1 ? "s" : "") + " (any fragrance) and save " + inr(s2) + ". Totally optional." +
            '<div><a class="ssm-link" href="' + OFFER + '">Mix &amp; save →</a></div>';
        }
        host.parentNode.insertBefore(box, host);
      }).catch(function () {});
  }

  function run() { strip(); pdp(); cartBox(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
